import React, { useEffect, useState } from 'react';
import styles from './AcessoRapido.module.css';
import Input from '../Form/Input';
import useForm from '../Hooks/useForm';
import { USER_GET_CPF } from '../../api';
import { useUserContext } from '../../UserContext';
import { useParams } from 'react-router-dom';

const AcessoRapido = () => {
  const cpf = useForm('cpf');
  const [cpfToken, setCpfToken] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const { userLoginToken } = useUserContext();

  // 🔹 Token vindo da rota (mesmo comportamento do LoginPasswordReset)
  const { token } = useParams<{ token: string }>();

  // 🔹 Buscar CPF a partir do token
  useEffect(() => {
    async function fetchCpfFromToken() {
      if (!token) {
        setError('Token não encontrado na URL.');
        return;
      }

      try {
        setLoading(true);
        const { url, options } = USER_GET_CPF(token);
        const response = await fetch(url, options);
        const json = await response.json();

        if (!response.ok) {
          throw new Error(json?.message || 'Token inválido.');
        }

        // Backend retorna algo como { cpf: "82742489029" }
        setCpfToken(json.cpf);
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError('Ocorreu um erro desconhecido.');
        }
      } finally {
        setLoading(false);
      }
    }

    fetchCpfFromToken();
  }, [token]);

  // 🔹 Comparar CPF digitado com CPF do token
  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError('');
    setSuccess('');

    const inputCpf = cpf.value.replace(/\D/g, '');
    const tokenCpf = cpfToken.replace(/\D/g, '');

    if (!inputCpf) {
      setError('Por favor, digite seu CPF.');
      return;
    }

    if (inputCpf !== tokenCpf) {
      setError('O CPF informado não confere com o do link.');
      return;
    }

    if (!token) {
      setError('Token não encontrado na URL.');
      return;
    }

    try {
      await userLoginToken(token);
    } catch (err: any) {
      if (err?.status === 401) {
        setError(
          'Este link de acesso não é mais válido. Solicite um novo acesso.',
        );
      } else {
        setError('Não foi possível realizar o login. Tente novamente.');
      }
    }
  }

  return (
    <div className={styles.containerForm}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <h1>
          Confirme seu CPF para realizar o seu primeiro acesso
          <span className={styles.ponto}>.</span>
        </h1>

        <Input
          name="cpf"
          type="text"
          label="CPF"
          maxLength={14}
          placeholder="Digite seu CPF aqui..."
          {...cpf}
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Carregando...' : 'ENVIAR'}
        </button>

        {error && <p className={styles.error}>{error}</p>}
        {success && <p className={styles.success}>{success}</p>}
      </form>
    </div>
  );
};

export default AcessoRapido;
